// Sports Day art pack — self-contained inline SVGs (no external assets) that
// swap in for the ink pot / hand-pen / books stack when the Sports Meet preset
// is applied. They're base64-inlined so they participate in html-to-image and
// PDF exports and require no network fetches.

const svg = (body) => `data:image/svg+xml;utf8,${encodeURIComponent(body)}`;

// Trophy (replaces the ink pot slot — mid-left).
export const SPORTS_TROPHY = svg(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 260 340" width="260" height="340">
  <defs>
    <linearGradient id="gold" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#ffe07a"/>
      <stop offset="0.55" stop-color="#e5b800"/>
      <stop offset="1" stop-color="#8a6300"/>
    </linearGradient>
    <linearGradient id="cupSide" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffdd6a"/>
      <stop offset="1" stop-color="#b8860b"/>
    </linearGradient>
  </defs>
  <!-- handles -->
  <path d="M 40 90 C -6 120 8 190 60 195" fill="none" stroke="url(#gold)" stroke-width="14" stroke-linecap="round"/>
  <path d="M 220 90 C 266 120 252 190 200 195" fill="none" stroke="url(#gold)" stroke-width="14" stroke-linecap="round"/>
  <!-- cup body -->
  <path d="M 40 80 h 180 v 60 c 0 60 -40 100 -90 100 s -90 -40 -90 -100 z" fill="url(#cupSide)" stroke="#7a5500" stroke-width="3"/>
  <!-- rim -->
  <rect x="35" y="72" width="190" height="18" rx="3" fill="url(#gold)" stroke="#7a5500" stroke-width="3"/>
  <!-- star -->
  <path d="M 130 130 l 12 26 l 28 4 l -21 20 l 6 28 l -25 -14 l -25 14 l 6 -28 l -21 -20 l 28 -4 z" fill="#fff8e5" stroke="#7a5500" stroke-width="2"/>
  <!-- stem -->
  <rect x="115" y="240" width="30" height="24" fill="url(#gold)" stroke="#7a5500" stroke-width="3"/>
  <!-- base -->
  <path d="M 70 264 h 120 l -14 30 h -92 z" fill="url(#gold)" stroke="#7a5500" stroke-width="3"/>
  <rect x="60" y="294" width="140" height="18" rx="3" fill="url(#gold)" stroke="#7a5500" stroke-width="3"/>
  <!-- shadow -->
  <ellipse cx="130" cy="325" rx="90" ry="6" fill="#000" opacity="0.18"/>
</svg>`);

// Runner / medal (replaces the hand-pen slot — top-right).
export const SPORTS_RUNNER = svg(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 260 260" width="260" height="260">
  <defs>
    <linearGradient id="medalG" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffe07a"/>
      <stop offset="1" stop-color="#b8860b"/>
    </linearGradient>
  </defs>
  <!-- ribbon -->
  <path d="M 90 10 L 110 100 L 130 90 L 150 100 L 170 10 Z" fill="#DC2626" stroke="#7a1516" stroke-width="2"/>
  <path d="M 130 90 L 150 100 L 130 130 L 110 100 Z" fill="#a01818"/>
  <!-- medal disc -->
  <circle cx="130" cy="170" r="70" fill="url(#medalG)" stroke="#7a5500" stroke-width="4"/>
  <circle cx="130" cy="170" r="56" fill="none" stroke="#fff8e5" stroke-width="2" stroke-dasharray="3 3"/>
  <!-- laurel leaves inside -->
  <g stroke="#7a5500" stroke-width="2" fill="#4d8b3d">
    <path d="M 88 190 q -14 -20 -8 -46 q 14 12 12 30 q -2 12 -4 16 z"/>
    <path d="M 172 190 q 14 -20 8 -46 q -14 12 -12 30 q 2 12 4 16 z"/>
  </g>
  <text x="130" y="180" text-anchor="middle" font-family="Merriweather, serif" font-weight="900" font-size="46" fill="#7a4900">1</text>
  <!-- star sparkles -->
  <g fill="#DC2626">
    <path d="M 60 40 l 4 10 l 10 2 l -8 6 l 2 10 l -8 -5 l -8 5 l 2 -10 l -8 -6 l 10 -2 z"/>
    <path d="M 210 30 l 3 8 l 8 1 l -6 5 l 2 8 l -7 -4 l -7 4 l 2 -8 l -6 -5 l 8 -1 z"/>
  </g>
</svg>`);

// Stadium torch (replaces the books slot — bottom-left).
export const SPORTS_TORCH = svg(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 260" width="320" height="260">
  <defs>
    <radialGradient id="flame" cx="0.5" cy="0.7" r="0.6">
      <stop offset="0" stop-color="#fff2a8"/>
      <stop offset="0.5" stop-color="#f4b731"/>
      <stop offset="0.9" stop-color="#DC2626"/>
      <stop offset="1" stop-color="#7a1516"/>
    </radialGradient>
    <linearGradient id="cup" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#e5b800"/>
      <stop offset="1" stop-color="#8a6300"/>
    </linearGradient>
    <linearGradient id="handle" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#3a5aa0"/>
      <stop offset="1" stop-color="#132749"/>
    </linearGradient>
  </defs>
  <!-- flame -->
  <path d="M 148 10 C 122 60 82 66 92 132 C 100 172 132 200 168 200 C 220 200 258 156 236 106 C 220 68 200 78 190 46 C 184 74 174 60 168 34 C 164 60 156 32 148 10 z"
        fill="url(#flame)" stroke="#7a1516" stroke-width="2"/>
  <path d="M 168 60 C 148 90 130 100 140 140 C 148 168 174 178 194 168 C 214 158 220 130 208 108 C 200 92 196 100 190 82 z"
        fill="#ffe580" opacity="0.7"/>
  <!-- torch cup -->
  <path d="M 96 196 h 148 l -20 40 h -108 z" fill="url(#cup)" stroke="#7a5500" stroke-width="3"/>
  <rect x="88" y="192" width="164" height="14" rx="3" fill="#e5b800" stroke="#7a5500" stroke-width="3"/>
  <!-- handle -->
  <rect x="140" y="230" width="60" height="18" rx="4" fill="url(#handle)" stroke="#0a1c40" stroke-width="2"/>
  <rect x="130" y="244" width="80" height="10" rx="3" fill="#e5b800" stroke="#7a5500" stroke-width="2"/>
  <!-- shadow -->
  <ellipse cx="170" cy="256" rx="90" ry="4" fill="#000" opacity="0.18"/>
</svg>`);

export const SPORTS_ART_PACK = {
  art_ink:   SPORTS_TROPHY,
  art_pen:   SPORTS_RUNNER,
  art_books: SPORTS_TORCH,
};
